import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Table } from "../../../Component/Table/Table";
import { image_proof, okiee } from "../../../assets/img";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Select from "react-select";
import SingleTable from "../../../Component/Table/SingleTable";
import ImagePopup from "../../../Component/ImagePopup";
import moment from "moment";
import { URLS } from "../../redux/api/Constants";
import { get, post } from "../../redux/api/ApiHandler";
import { userDetails } from "../../../Component/userDetails";
import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";
import SingleTable2 from "../../../Component/Table/SingleTable2";


const NextVisitView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const formType = location.state?.type; // "add" | "edit" | "view"
    const existingData = location.state?.data; // Prefill for edit/view
    const isViewMode = formType === "view";
    const isEditMode = formType === "edit";
    const [pagination, setPagination] = useState("");
    const [regionOptions, setRegionOptions] = useState([]);
    const [fromDates, setFromDates] = useState(null);
    const [toDates, setToDates] = useState(null);
    const [selFrom, setSelFrom] = useState("");
    const [selTo, setSelTo] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [description, setDescription] = useState("");
    const [regionId, setRegionId] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [cusPrinterId, setCusPrinterId] = useState(null);
    const [servEngId, setServEngId] = useState(null);
    const [regManId, setRegManId] = useState(null);
    const [page, setPage] = useState(1);
    const [list, setList] = useState([]);
    const [proof, setProof] = useState([]);
    const [popup, setPopup] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [flow, setFlow] = useState([]);
    const [staticFlow, setStaticFlow] = useState([]);
    const [WorkCompleted, setWrokCompleted] = useState();
    const [closedTable, setClosedTable] = useState();
    const [supportNeed, setSupportNeed] = useState("");
    const [assigned, setAssigned] = useState([])

    const id = location?.state?.id;
    const status = location?.state?.status;

    let user = userDetails();

    const admin_id = user?.id;
    const closeby = user?.name;
    const role = user?.role == 1 ? "Super Admin" : "";


    const {
        control,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: {
            employeeId: "",
            employeeName: "",
            email: "",
            mobile: "",
            role: "",
            tickedclosed: closeby,

        },
    });

    const viewAdmin = async () => {
        let res = await get(URLS.TICKET_VIEW + id)
        setList(res?.data?.customer_printer)


        if (res?.status === "success" && res?.data) {
            if (res?.status === "success" && res?.data) {
                const region_id = res?.data?.region?.id;
                const customer_id = res?.data?.customer?.id;
                const customer_printer_id = res?.data?.customer_printer?.id;
                const service_engineer_id = res?.data?.service_engineer?.id;
                const region_manager_id = res?.data?.regional_manager?.id;
                setRegionId(region_id);
                setCusPrinterId(customer_printer_id);
                setRegManId(region_manager_id);
                setServEngId(service_engineer_id);
                setCustomerId(customer_id);

            }
            const admin = res?.data;
            const admin_ticket = admin?.ticket_details?.[0];

            // table
            const work_completed = admin?.ticket_details?.find(i => i?.support_needed == 5);
            setWrokCompleted(work_completed);
            const work_closed = admin?.status == 4 && admin;
            setClosedTable(work_closed);

            // Assigned Loop
            const loopTable = admin?.ticket_details.filter(item => item?.moved_to == null)?.sort((a, b) => a.id - b.id) || [];
            const remainingLoop = loopTable.slice(1);
            setAssigned(remainingLoop);


            // support need
            const ticketDetails = admin?.ticket_details;
            const supportNeed = ticketDetails[ticketDetails.length - 1]?.support_needed;
            setValue("supportneed", supportNeed == 1 ? "Technical" : supportNeed == 2 ? "Inventory" : supportNeed == 3 ? " Next Visit" : supportNeed == 4 ? "Senior Support" : supportNeed == 5 ? "Work Completed" : "-");
            setSupportNeed(admin_ticket?.support_needed)

            // image and vedio proofs
            const sorted = [...admin.ticket_details].sort(
                (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
            );
            const latestProofItem = sorted.find(i => i.proofs?.length > 0);
            setProof(latestProofItem?.proofs || []);

            // remarks
            setValue("remarks", latestProofItem?.remarks || "-")

            // flow diagram
            const flowArr = admin?.ticket_details.filter(item => item?.moved_to == null)?.sort((a, b) => a.id - b.id) || [];
            const remaining = flowArr.slice(1);
            setFlow(remaining);

            // fault type
            setValue("faulttype", admin?.ticket_details?.[0]?.fault_type || "-")
            setValue("issueEngineer", admin?.ticket_details?.[0]?.issue_desc || "-")
            setValue("workdate", moment(work_completed?.closed_at).format("DD-MM-YYYY") || "-")
            setValue("worktime", moment(work_completed?.closed_at).format("hh:mm A") || "-")
            setValue("pendingtime", moment(admin?.ticket_details?.[0]?.updated_at).format("DD-MM-YYYY") || "-")
            setValue("pendingdate", moment(admin?.ticket_details?.[0]?.updated_at).format("hh:mm:ss A") || "-")
            setValue("assigndate", moment(admin?.ticket_details?.[0]?.assigned_at).format("DD-MM-YYYY") || "-")
            setValue("assigntime", moment(admin?.ticket_details?.[0]?.assigned_at).format("hh:mm A") || "-")
            setValue("status", admin?.current_status == 7 ? "Next Visit" : "-");


            setValue("visitdate", moment(admin?.ticket_details?.[0]?.updated_at).format("DD-MM-YYYY") || "-")
            // console.log("admin_ticket", proof);
            setValue("region", admin?.region?.name || "-");
            setValue("regionalmanager", admin?.regional_manager?.name || "-");
            setValue("serviceengineer", admin?.service_engineer?.name || "-");
            setValue("customerID", admin?.customer?.code || "-");
            setValue("customername", admin?.customer?.name || "-");
            setValue("email", admin?.customer?.email || "-")
            setValue("mobile", admin?.customer?.mobile || "-")
            setValue("Secondarymobile", admin?.customer?.secondary_mobile || "-")
            setValue("address", admin?.customer?.address || "-")
            setValue("issue", admin?.customer_issue || "-")
            setValue("createdby", (admin?.created_by ? `${admin?.created_by?.name} - ${admin?.created_by?.role == 1 ? "Super Admin" : admin?.created_by?.role == 2 ? "Inventory" : admin?.created_by?.role == 3 ? "Technical Engineer" : admin?.created_by?.role == 4 ? "Regional Manager" : admin?.created_by?.role == 5 ? "Service Engineer" : "-"}` : "-"));
            setValue("createddate", moment(admin?.created_at).format("DD-MM-YYYY") || "-")
            setValue("opendate", moment(admin?.opened_at).format("DD-MM-YYYY") || "-")
            setValue("opentime", moment(admin?.opened_at).format("hh:mm A") || "-")
            // setValue("tickedclosed", closeby || "-")

        }
    }



    useEffect(() => {
        viewAdmin()
    }, [])

    const closeTicket = async () => {
        if (!description) {
            toast.error("Enter Description");
            return;
        }
        let payload = {
            issue_desc: description,
            status: 4,
            region_id: regionId,
            regional_manager_id: regManId,
            service_engineer_id: servEngId,
            customer_printer_id: cusPrinterId,
            customer_id: customerId,
            closed_by: admin_id,
        }
        let res = await post(URLS.TICKET_CLOSE + id, payload)
        if (res?.status == "success") {
            toast.success(res?.message);
            setPopup(false);
            navigate("/next-visit");

        }
    }








    const passwordValue = watch("password");




    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: "8px",
            borderColor: "#1A77BC",
            minHeight: "40px",
            fontSize: "14px",
            backgroundColor: "#1978BC",
            color: "white",
            boxShadow: state.isFocused ? "0 0 0 1px #1978BC" : "none",
            "&:hover": {
                borderColor: "#1978BC",
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "white", // font color inside the selected value
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "white", // placeholder text color
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: "white", // arrow icon color
            "&:hover": {
                color: "white",
            },
        }),
        input: (provided) => ({
            ...provided,
            color: "white", // text color while typing
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: "#1978BC", // dropdown background
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "#1A77BC" : "#1978BC",
            color: "white",
            "&:active": {
                backgroundColor: "#1565A6",
            },
        }),
    };
    const couponOptions = [
        { value: "north", label: "North Region" },
        { value: "south", label: "South Region" },
        { value: "east", label: "East Region" },
        { value: "west", label: "West Region" },
    ];

    useEffect(() => {
        if (existingData) {
            Object.entries(existingData).forEach(([key, value]) => {
                setValue(key, value);
            });
        }
    }, [existingData, setValue]);


    return (
        <div>
            <Topbar
                header="Next Visit"
                subHead={isViewMode ? "View" : isEditMode ? "Edit" : "Add"}
            />

            {showPopup && (
                <ImagePopup showPopup={showPopup} setShowPopup={setShowPopup} />
            )}
            <div className="container_fluit1 px-4 py-3">
                <div>
                    <div className="d-flex  mb-1 flex-wrap">
                        <div>
                            <div className="step d-flex ac-je">
                                <p className="step-number f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">1</p>
                            </div>
                            <h6 className="f1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-18 gray">Create</h6>
                        </div>
                        <div>
                            <div className="step d-flex ac-je">
                                <div className="step-line"></div>
                                <p className="step-number f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">2</p>
                            </div>
                            <div className="d-flex ac-je">
                                <h6 className="f1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-18 gray  w-50">Service Engineer</h6>
                            </div>
                        </div>
                        {flow.map((item, index) => {
                            const roles = {
                                1: "Technical",
                                2: "Inventory",
                                3: "Next Visit",
                                4: "Senior Support",
                                5: "Work Completed",
                            };
                            return (
                                <div className="" key={index}>
                                    <div className="d-flex ac-js">
                                        <div className="step-line"></div>
                                        <div className="step">
                                            <p className={`${index == flow?.length - 1 ? "step-number2" : "step-number"} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-18 `}>{index + 3}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex ac-je">
                                        <h6 className="f1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-18 gray  w-50 ">{roles[item?.support_needed] || ""}</h6>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                <form
                    className="d-flex flex-wrap gap-5 mt-5"

                >
                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="region"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Region <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.region && (
                                        <p style={{ color: "red" }}>{errors.region.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="regionalmanager"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Regional Manager <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.regionalmanager && (
                                        <p style={{ color: "red" }}>
                                            {errors.regionalmanager.message}
                                        </p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="serviceengineer"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Service Engineer <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.serviceengineer && (
                                        <p style={{ color: "red" }}>
                                            {errors.serviceengineer.message}
                                        </p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="customerID"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Customer ID <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.customerID && (
                                        <p style={{ color: "red" }}>{errors.customerID.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="customername"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Customer Name <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.customername && (
                                        <p style={{ color: "red" }}>
                                            {errors.customername.message}
                                        </p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    {/* Email */}
                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="email"
                            rules={{
                                required: "Email is required",
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Invalid email format",
                                },
                            }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Email <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field} type="email"
                                        className="input-box"
                                        placeholder="Enter Email"
                                        disabled
                                    />
                                    {errors.email && (
                                        <p style={{ color: "red" }}>{errors.email.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    {/* Mobile */}
                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="mobile"
                            rules={{
                                required: "Mobile number is required",
                                pattern: {
                                    value: /^[0-9]{10}$/,
                                    message: "Mobile number must be 10 digits",
                                },
                            }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Mobile Number<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Mobile Number"
                                        disabled
                                    />
                                    {errors.mobile && (
                                        <p style={{ color: "red" }}>{errors.mobile.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="Secondarymobile"
                            rules={{
                                required: "Mobile number is required",
                                pattern: {
                                    value: /^[0-9]{10}$/,
                                    message: "Mobile number must be 10 digits",
                                },
                            }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Secondary Number<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Mobile Number"
                                        disabled
                                    />
                                    {errors.Secondarymobile && (
                                        <p style={{ color: "red" }}>
                                            {errors.Secondarymobile.message}
                                        </p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-11">
                        <Controller
                            control={control}
                            name="address"
                            rules={{ required: "Role is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Address <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Role"
                                        disabled
                                    />
                                    {errors.address && (
                                        <p style={{ color: "red" }}>{errors.address.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>
                </form>
                <label className="f3 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 mt-5">
                    Printer Details
                </label>
                <div className="static-table-design">
                    <table className=" table-border  static-table">
                        <thead><tr className=" thfiled table_header">
                            <th>S.No</th>
                            <th>Printer ID</th>
                            <th>Warrenty Start Date</th>
                            <th>End Date</th>
                            <th>AMC Start Date</th>
                            <th>End Date</th>
                        </tr></thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>{list?.sr_no}  <img
                                    src={okiee}
                                    alt="printer"
                                    width="20"
                                    height="20"
                                    style={{ objectFit: "contain" }}
                                /></td>
                                <td>{moment(list?.wr_start_date).format("DD-MM-YYYY")}</td>
                                <td>{moment(list?.wr_end_date).format("DD-MM-YYYY")}</td>
                                <td>{moment(list?.amc_start_date).format("DD-MM-YYYY")}</td>
                                <td>{moment(list?.amc_end_date).format("DD-MM-YYYY")}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <form className="d-flex flex-wrap gap-5"   >
                    <div className="col-md-11 mt-5">
                        <Controller
                            control={control}
                            name="issue"
                            rules={{ required: "Role is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Issue Description By Customer <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Role"
                                        disabled
                                    />
                                    {errors.issue && (
                                        <p style={{ color: "red" }}>{errors.issue.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div >


                    {/* <div className="col-lg-4">
                        <label
                            className="f3 fs-sm-12 fs-md-17 fs-lg-18 fs-xl-19 fs-xxl-20 mb-2"
                            style={{ color: "#323691" }}
                        >
                            Video Proof
                        </label>
                        {proof.map((item) => {
                            return (
                                <div>
                                    {item?.status == "Video" && (
                                        <video className="video-proof-box" width="300" height="200px" controls autoPlay={false} >
                                            <source src={item?.file_url} type="video/mp4" />
                                        </video>
                                    )}
                                </div>
                            )
                        })}
                        {!proof?.some((item) => item.status === "Video") && (
                            <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
                                No Video proof Uploaded
                            </p>
                        )}
                    </div>
                    <div className="col-lg-6 ">
                        <label
                            className="f3 fs-sm-12 fs-md-17 fs-lg-18 fs-xl-19 fs-xxl-20 mb-2"
                            style={{ color: "#323691" }}
                        >
                            Image Proof
                        </label>
                        <div className="d-flex flex-wrap ac-js gap-3">
                            {proof.map((item, ind) => {
                                return (
                                    <div key={ind}>
                                        {item?.status == "Image" && (
                                            <div >
                                                <img role="button" onClick={() => setShowPopup(item?.file_url)} src={item?.file_url} className="image_proof" />

                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div> */}



                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="faulttype"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Fault Type <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Created by "
                                        disabled
                                    />
                                    {errors.faulttype && (
                                        <p style={{ color: "red" }}>{errors.faulttype.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-11 mt-3">
                        <Controller
                            control={control}
                            name="issue"
                            rules={{ required: "Role is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Issue Description By Service Engineer <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Role"
                                        disabled
                                    />
                                    {errors.issue && (
                                        <p style={{ color: "red" }}>{errors.issue.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div >

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="createdby"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Created by <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Created by "
                                        disabled
                                    />
                                    {errors.createdby && (
                                        <p style={{ color: "red" }}>{errors.createdby.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>


                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="createddate"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Created Date <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.createddate && (
                                        <p style={{ color: "red" }}>{errors.createddate.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="opendate"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Open Date <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Created by "
                                        disabled
                                    />
                                    {errors.opendate && (
                                        <p style={{ color: "red" }}>{errors.opendate.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="opentime"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Open Time <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.opentime && (
                                        <p style={{ color: "red" }}>{errors.opentime.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>
                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="pendingdate"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Pending Date <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Created by "
                                        disabled
                                    />
                                    {errors.pendingdate && (
                                        <p style={{ color: "red" }}>{errors.pendingdate.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>

                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="pendingtime"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Pending Time <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.pendingtime && (
                                        <p style={{ color: "red" }}>{errors.pendingtime.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>


                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="assigndate"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Assign Date <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.assigndate && (
                                        <p style={{ color: "red" }}>{errors.assigndate.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>
                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="assigntime"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Assign Time <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.assigntime && (
                                        <p style={{ color: "red" }}>{errors.assigntime.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>
                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="status"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Status <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="Enter Employee ID"
                                        disabled
                                    />
                                    {errors.status && (
                                        <p style={{ color: "red" }}>{errors.status.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>
                    <div className="col-md-5">
                        <Controller
                            control={control}
                            name="visitdate"
                            rules={{ required: "Employee ID is required" }}
                            render={({ field }) => (
                                <div>
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Visit Date <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        {...field}
                                        className="input-box"
                                        placeholder="visit date"
                                        disabled
                                    />
                                    {errors.status && (
                                        <p style={{ color: "red" }}>{errors.status.message}</p>
                                    )}
                                </div>
                            )}
                        />
                    </div>
                    {assigned.map((item) => {
                        let support = item?.support_needed
                        return (
                            <div className="d-flex flex-wrap gap-5 w-100">
                                <div className="col-md-5">
                                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                        Support Need<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Controller
                                        control={control}
                                        name="supportneed"
                                        rules={{ required: "Coupon Type is required" }}
                                        render={({ field }) => (
                                            <div>
                                                <input
                                                    value={support == 1 ? "Technical" : support == 2 ? "Inventory" : support == 3 ? " Next Visit" : support == 4 ? "Senior Support" : support == 5 ? "Work Completed" : "-"}
                                                    className="input-box"
                                                    placeholder="Enter Status"
                                                    disabled={true}
                                                    style={{ backgroundColor: "#1978BC", color: "white" }}
                                                />
                                            </div>
                                        )}
                                    />
                                </div>
                                <div className="col-md-5">
                                    <Controller
                                        control={control}
                                        name="pendingtime"
                                        rules={{ required: "Employee ID is required" }}
                                        render={({ field }) => (
                                            <div>
                                                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                                    {support == 1 ? "Technical" : support == 2 ? "Inventory" : support == 3 ? " Next Visit" : support == 4 ? "Senior Support" : support == 5 ? "Work Completed" : "-"} Assign Date <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    value={moment(item?.assigned_at).format("DD-MM-YYYY")}
                                                    className="input-box"
                                                    placeholder="Enter Employee ID"
                                                    disabled
                                                />
                                                {errors.opentime && (
                                                    <p style={{ color: "red" }}>{errors.opentime.message}</p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </div>
                                <div className="col-md-5">
                                    <Controller
                                        control={control}
                                        name="pendingtime"
                                        rules={{ required: "Employee ID is required" }}
                                        render={({ field }) => (
                                            <div>
                                                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                                    {support == 1 ? "Technical" : support == 2 ? "Inventory" : support == 3 ? " Next Visit" : support == 4 ? "Senior Support" : support == 5 ? "Work Completed" : "-"} Assign Time <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    value={moment(item?.assigned_at).format("hh:mm A")}
                                                    className="input-box"
                                                    placeholder="Enter Employee ID"
                                                    disabled
                                                />
                                                {errors.opentime && (
                                                    <p style={{ color: "red" }}>{errors.opentime.message}</p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </div>
                                <SingleTable2 WorkCompleted={item} />
                            </div>
                        )
                    })}
                </form>
                {/* <SingleTable /> */}

                {!isViewMode && (
                    <>
                        <div className="col-md-5 mt-5">
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                Support Need<span style={{ color: "red" }}>*</span>
                            </label>
                            <Controller
                                control={control}
                                name="supportneed"
                                rules={{ required: "Coupon Type is required" }}
                                render={({ field }) => (
                                    <div>
                                        <Select
                                            {...field}
                                            // options={couponOptions}
                                            placeholder="Next Visit"
                                            isSearchable
                                            onChange={field.onChange}
                                            value={field.value}
                                            styles={customStyles}
                                            isDisabled
                                        />
                                        {errors.supportneed && (
                                            <p style={{ color: "red" }}>{errors.supportneed.message}</p>
                                        )}
                                    </div>
                                )}
                            />
                        </div>
                    </>
                )}

                {/* Buttons */}
                <div className="d-flex col-md-11 ac-jb my-5">
                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
                    >
                        Back
                    </button>
                    {!isViewMode && (
                        <div className="d-flex ac-jc gap-4">
                            <button
                                type="submit"
                                onClick={() => setPopup(true)}
                                className="ticket_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
                            >
                                Ticket Close

                            </button>
                            <button
                                type="submit"
                                onClick={() => navigate("/next-move", { state: { team: supportNeed, id: id, regionId: regionId, regManId: regManId, servEngId: servEngId, customerId: customerId, cusPrinterId: cusPrinterId, status: status } })}

                                className="move_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
                            >
                                Move
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {popup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className="d-flex ac-je">
                            <p className="popup-close-btn" onClick={() => setPopup(false)}>
                                <CloseIcon />
                            </p>
                        </div>
                        <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 d-flex ac-js">
                            Description
                        </label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)}
                            placeholder="-Enter Description-"
                            className="form-control f2 fs-sm-13 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-15"
                            style={{
                                borderRadius: "8px",
                                borderColor: "#D9D9D9",
                                width: "100%",
                                minHeight: "100px",
                                padding: "10px",
                                fontSize: "10px",
                                resize: "vertical",
                                outline: "none",
                            }}
                            disabled={isViewMode}
                        />
                        <div className="my-3">
                            <Controller
                                control={control}
                                name="tickedclosed"
                                render={({ field }) => (
                                    <div>
                                        <label className="f3 d-flex ac-js fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                                            Ticket Closed By
                                        </label>
                                        <input
                                            // {...field}
                                            value={closeby}
                                            className="input-box"
                                            disabled
                                        />
                                        <input
                                            // {...field}
                                            value={role}
                                            className="input-box"
                                            disabled
                                        />
                                        {errors.tickedclosed && (
                                            <p style={{ color: "red" }}>{errors.tickedclosed.message}</p>
                                        )}
                                    </div>
                                )}
                            />
                        </div>
                        <div className="d-flex ac-je">
                            <button onClick={() => closeTicket()}
                                className="yes-btn f2 w-40  ">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NextVisitView;
